import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useDeleteCompanySpecialEntry } from '@/features/privateCompanies/hooks/useDeleteCompanySpecialEntry'
import { useQueryClient } from '@tanstack/react-query'
import { XIcon } from 'lucide-react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ModalDeleteSpecialEntryProps {
  specialEntryId: string
  disabled?: boolean
}

export const ModalDeleteSpecialEntry = ({ specialEntryId, disabled }: ModalDeleteSpecialEntryProps) => {
  const { id: companyId } = useParams()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['company', companyId] })
  }

  const onError = (error: any) => {
    if (error.response?.data.errors.base) {
      setMessages(error.response?.data.errors.base)
    } else {
      setMessages(['Ocorreu um erro no servidor tente novamente.'])
    }
  }

  const {
    mutate: deleteSpecialEntry,
    isPending: deleteSpecialEntryIsPending,
    isError: deleteCompanySpecialEntryIsError,
  } = useDeleteCompanySpecialEntry({
    companyId,
    onSuccess,
    onError,
  })

  return (
    <>
      {messages ? (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={deleteCompanySpecialEntryIsError}
          onClose={() => {
            setIsOpen(false)
          }}
        />
      ) : (
        <Modal
          Trigger={
            <Button type="button" variant="outline-error" className="size-[54px] mt-auto" disabled={disabled}>
              <XIcon />
            </Button>
          }
          triggerDisabled={disabled}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          title="Você tem certeza?"
          showClose={false}
          useCancellableFooter
          confirmButtonText="Deletar Tarifa Especial"
          disabled={deleteSpecialEntryIsPending}
          onConfirm={() => deleteSpecialEntry(specialEntryId)}
        />
      )}
    </>
  )
}
